import React from 'react'
import { clone } from 'ramda'
const { isValidElement, Children } = React

/// In development, we compare based on the name of the function because
/// React Hot Loader proxies React components in order to make updates. In
/// production we can simply compare the components for equality.
const isComponent = (AComponent, AnotherComponent) => AComponent === AnotherComponent

/// Checks whether `element` is a React element of type `Component` (or one of
/// the passed components, if `Component` is an array of React components).
export function isElementOfType(element, Component) {
  if (element == null || !isValidElement(element) || typeof element.type === 'string') {
    return false
  }

  const { type } = element
  const Components = Array.isArray(Component) ? Component : [Component]

  return Components.some(AComponent => typeof type !== 'string' && isComponent(AComponent, type))
}

export function wrapWithComponent(element, Component, props) {
  if (element == null) {
    return null
  }
  return isElementOfType(element, Component) ? element : React.createElement(Component, clone(props), element)
}

/// Returns all children that are valid elements as an array. Can optionally be
/// filtered by passing `predicate`.
export function elementChildren(children) {
  return Children.toArray(children).filter(child => isValidElement(child))
}



// WEBPACK FOOTER //
// ./src/utils/components.js